import { GetRealClustersResponse } from 'shared/types/Clusters';
import { Cluster } from 'shared/types/Map';

export function clustersSelector(data: GetRealClustersResponse): Cluster[] {
  return data.clusters;
}

export function nextZoomSelector(data: GetRealClustersResponse): number | undefined {
  return data.nextZoom;
}
